import type { PreviewResponseMessage, PreviewSocketDataMessage } from "@innoclouds/ui";
import { patchAxios } from "./axios";
import { patchBeacon, patchFetch, patchXhr } from "./http";
import { createLocalLink } from "./local";
import { patchWebSocket, receiveSocketData } from "./socket";
import { receiveResponse, setBackendLink } from "./transport";

export const installPreviewBackend = () => {
	patchFetch();
	patchXhr();
	patchBeacon();
	patchAxios();
	patchWebSocket();
};

export const installMockBackend = () => {
	setBackendLink(createLocalLink());
	installPreviewBackend();
};

export const receivePreviewBackend = (message: PreviewResponseMessage | PreviewSocketDataMessage) => {
	if (message.type === "response") receiveResponse(message);
	else receiveSocketData(message);
};
